module.exports = __webpack_public_path__ + "static/media/award-5.77deb9a0.png";